export const COMETCHAT_CONSTANTS = {
  APP_ID: '202641f66c43eadd',
  REGION: 'eu',
  AUTH_KEY: 'cab8ca22fde795f8a1437d9e7fec1fc393727ea1'
}